module.exports = __webpack_public_path__ + "img/test_active.ec1f2fd6.svg";